import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";

import {
  adminDashboardMenu,
  userDashboardMenu,
  wareHouseDashboardMenu,
} from "../../helper/sidebarPath/SidebarPath";

const MobileSidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubMenuClicked, setIsSubMenuClicked] = useState(false);
  const [subMenuClicked, setSubMenuClicked] = useState("");
  const [userType, setUserType] = useState("");

  useEffect(() => {
    // Get the token from local storage or wherever it's stored
    const token = localStorage.getItem("token");

    if (token) {
      try {
        const decodedToken = jwtDecode(token);
        // Assuming your token's payload has a `userType` claim
        setUserType(decodedToken.userType);
      } catch (error) {
        console.error("Invalid token:", error);
        // Handle invalid token, e.g., redirect to login
        setUserType("");
      }
    }
  }, []);

  let userRoute = [];

  if (userType === "admin") {
    userRoute = adminDashboardMenu;
  } else if (userType === "warehouse") {
    userRoute = wareHouseDashboardMenu;
  } else {
    userRoute = userDashboardMenu;
  }

  return (
    <div className="w-full">
      {isOpen ? (
        <div
          className="
            fixed top-0 left-0 w-full z-[9999]
            backdrop-blur-md bg-[#f2edf399]
            shadow-inner border-b border-[#f2edf3]
            py-5
          "
        >
          <div
            className="flex justify-end w-full pr-4"
            onClick={() => setIsOpen(false)}
          >
            <CloseIcon className="text-2xl cursor-pointer" />
          </div>

          {userRoute &&
            userRoute.map((route) => (
              <div key={route?.name}>
                {/* Routes without submenu */}
                {!route?.submenu?.length && (
                  <NavLink
                    to={route.path}
                    onClick={() => setIsOpen(false)}
                    className={({ isActive }) =>
                      `flex items-center relative py-4 text-lg font-semibold ${
                        isActive ? "text-primary" : "text-black"
                      }`
                    }
                  >
                    <div className="pl-8">{route?.icon}</div>
                    <div className="pl-4">{route?.name}</div>
                    <div className="absolute left-0 top-0 bottom-0 w-1 bg-primary" />
                  </NavLink>
                )}

                {/* Routes with submenu */}
                {route?.submenu?.length && (
                  <div>
                    <div
                      className="flex items-center relative py-4 text-lg font-semibold cursor-pointer"
                      onClick={() => {
                        if (subMenuClicked === route.name) {
                          setIsSubMenuClicked(!isSubMenuClicked);
                        } else {
                          setSubMenuClicked(route.name);
                          setIsSubMenuClicked(true);
                        }
                      }}
                    >
                      <div className="pl-8">{route?.icon}</div>
                      <div className="pl-4">{route?.name}</div>
                      <div className="pl-4">
                        {subMenuClicked === route?.name && isSubMenuClicked ? (
                          <ExpandLessIcon />
                        ) : (
                          <ExpandMoreIcon />
                        )}
                      </div>
                    </div>

                    {subMenuClicked === route?.name && isSubMenuClicked && (
                      <div>
                        {route?.submenu?.map((data) => (
                          <NavLink
                            key={data?.name}
                            to={data?.path}
                            onClick={() => {
                              setIsOpen(false);
                              setSubMenuClicked("");
                            }}
                            className={({ isActive }) =>
                              `flex items-center relative py-3 text-base font-medium ${
                                isActive ? "text-primary" : "text-black"
                              }`
                            }
                          >
                            <div className="pl-12">{data?.icon}</div>
                            <div className="pl-4">{data?.name}</div>
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))}
        </div>
      ) : (
        <nav
          onClick={() => setIsOpen(true)}
          className="
            flex justify-end w-full
            backdrop-blur-md bg-[#f2edf399]
            shadow-inner border-b border-[#f2edf3]
            py-2
          "
        >
          <MenuIcon className="text-2xl cursor-pointer mr-3" />
        </nav>
      )}
    </div>
  );
};

export default MobileSidebar;
